import { createContext, useContext, useState } from 'react';
import { InfoDialog } from 'components/common/InfoDialog';

export const InfoDialogContext = createContext(null);

export const useInfoDialog = () => {
  const context = useContext(InfoDialogContext);
  if (!context) {
    throw new Error('useInfoDialog must be used within InfoDialogProvider');
  }
  return context;
};

export const InfoDialogProvider = ({ children, ...props }) => {
  const [dialog, setDialog] = useState({
    confirmButtonText: 'Ok',
    handler: null,
    closeHandler: null,
    heading: '',
    illustration: null,
    show: false,
    text: '',
    title: '',
  });

  const closeInfoDialog = () => {
    dialog.closeHandler?.();
    setDialog({
      confirmButtonText: 'Ok',
      handler: null,
      heading: '',
      illustration: null,
      show: false,
      text: '',
      title: '',
    });
  };

  const openInfoDialog = (dialogData = {}) => {
    setDialog({
      ...dialog,
      show: true,
      ...dialogData,
    });
  };

  return (
    <InfoDialogContext.Provider
      value={{ dialog, closeInfoDialog, openInfoDialog }}
      {...props}
    >
      {children}
      <InfoDialog
        closeDialog={closeInfoDialog}
        confirmButtonText={dialog.confirmButtonText}
        handler={dialog.handler}
        heading={dialog.heading}
        illustration={dialog.illustration}
        show={dialog.show}
        text={dialog.text}
        title={dialog.title}
      />
    </InfoDialogContext.Provider>
  );
};
